import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { GuestGuard } from './guards/guest.guard';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [GuestGuard],
    loadComponent: () => import('./login/login').then((m) => m.Login),
  },
  {
    path: 'signup',
    canActivate: [GuestGuard],
    loadComponent: () => import('./signup/signup').then((m) => m.Signup),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./forgot-password/forgot-password').then((m) => m.ForgotPassword),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./shared/components/unauthorized/unauthorized').then((m) => m.Unauthorized),
  },
  {
    path: 'account-suspended',
    loadComponent: () =>
      import('./shared/components/account-suspended/account-suspended').then(
        (m) => m.AccountSuspended,
      ),
  },
  {
    path: 'subscription-expired',
    loadComponent: () =>
      import('./shared/components/subscription-expired/subscription-expired').then(
        (m) => m.SubscriptionExpired,
      ),
  },
  {
    path: 'subscription-required',
    loadComponent: () =>
      import('./shared/components/subscription-expired/subscription-expired').then(
        (m) => m.SubscriptionExpired,
      ),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'u',
    loadComponent: () => import('./page/page').then((m) => m.Page),
    loadChildren: () => import('./page/page.routes').then((m) => m.pagesRoutes),
    canActivate: [AuthGuard],
  },
  // Customer ordering pages (no navbar) — wrapped in CustomerLayout for shared theming
  {
    path: 'order/:orgSlug/:branchSlug',
    loadComponent: () =>
      import('./customer/customer-layout').then((m) => m.CustomerLayout),
    children: [
      {
        path: 'status',
        loadComponent: () =>
          import('./customer/order-status/order-status').then((m) => m.OrderStatus),
      },
      {
        path: ':orderId/status',
        loadComponent: () =>
          import('./customer/order-status/order-status').then((m) => m.OrderStatus),
      },
      {
        path: 'payment-pending',
        loadComponent: () =>
          import('./customer/payment-pending/payment-pending').then(
            (m) => m.PaymentPending,
          ),
      },
      {
        path: 'complete',
        loadComponent: () =>
          import('./customer/order-complete/order-complete').then(
            (m) => m.OrderComplete,
          ),
      },
      {
        path: ':tableId/checkout',
        loadComponent: () =>
          import('./customer/checkout/customer-checkout').then(
            (m) => m.CustomerCheckout,
          ),
      },
      {
        path: ':tableId',
        loadComponent: () =>
          import('./customer/order-form/customer-order').then((m) => m.CustomerOrder),
      },
      {
        path: '',
        loadComponent: () =>
          import('./customer/order-form/customer-order').then((m) => m.CustomerOrder),
      },
    ],
  },
  // Delivery ordering pages — dedicated QR flow
  {
    path: 'delivery/:orgSlug/:branchSlug',
    loadComponent: () =>
      import('./customer/customer-layout').then((m) => m.CustomerLayout),
    children: [
      {
        path: 'status',
        loadComponent: () =>
          import('./customer/order-status/order-status').then((m) => m.OrderStatus),
      },
      {
        path: ':orderId/status',
        loadComponent: () =>
          import('./customer/order-status/order-status').then((m) => m.OrderStatus),
      },
      {
        path: 'complete',
        loadComponent: () =>
          import('./customer/order-complete/order-complete').then(
            (m) => m.OrderComplete,
          ),
      },
      {
        path: '',
        loadComponent: () =>
          import('./customer/delivery-order/delivery-order').then((m) => m.DeliveryOrder),
      },
    ],
  },
  // Public Time Clock Kiosk (dedicated tablet / wall mount)
  {
    path: 'clock/:orgSlug/:branchSlug',
    loadComponent: () =>
      import('./public/time-clock-kiosk/time-clock-kiosk').then((m) => m.TimeClockKiosk),
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [GuestGuard],
    loadComponent: () => import('./public/home/home').then((m) => m.Home),
  },
  {
    path: '',
    loadComponent: () => import('./public/public').then((m) => m.Public),
    loadChildren: () => import('./public/public.routes').then((m) => m.routes),
    canActivate: [GuestGuard],
  },
];
